import { fetchAttributesByType } from "@/modules/offers/api/productModeration"
import type { ProductModerationAttribute } from "@/modules/offers/types/offers"

export const loadTypeAttributes = async (code: string): Promise<ProductModerationAttribute[]> => {
  const { data } = await fetchAttributesByType({ code })
  return data.results.map((attribute) => ({ ...attribute, value: [] }))
}
